import React, { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import {
  Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList,
} from "@/components/ui/command";
import { Button } from "@/components/ui/button";
import { Check, ChevronsUpDown, X } from "lucide-react";

export const normalizeText = (s) =>
  (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

// Búsqueda por nombre o apellidos en cualquier orden, sin tildes ni mayúsculas
export const playerMatches = (name, query) => {
  const nt = normalizeText(name);
  return normalizeText(query).split(/\s+/).filter(Boolean).every((tok) => nt.includes(tok));
};

export default function PlayerCombobox({
  players, value, onChange, placeholder = "Buscar jugador…", disabled = false,
  testId = "player-combobox", className = "w-56",
}) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const sorted = [...(players || [])].sort((a, b) => (a.name || "").localeCompare(b.name || "", "es"));
  const filtered = query ? sorted.filter((p) => playerMatches(p.name, query)) : sorted;
  const selected = sorted.find((p) => p.id === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" disabled={disabled}
          className={`${className} justify-between font-normal`} data-testid={testId}>
          <span className="truncate">{selected ? selected.name : placeholder}</span>
          {selected ? (
            <X className="h-4 w-4 shrink-0 opacity-60 hover:opacity-100"
              onClick={(e) => { e.stopPropagation(); onChange(""); }}
              data-testid={`${testId}-clear`} />
          ) : (
            <ChevronsUpDown className="h-4 w-4 shrink-0 opacity-50" />
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-0" align="start">
        <Command shouldFilter={false}>
          <CommandInput placeholder="Nombre o apellidos…" value={query} onValueChange={setQuery}
            data-testid={`${testId}-input`} />
          <CommandList>
            <CommandEmpty>Sin resultados.</CommandEmpty>
            <CommandGroup>
              {filtered.map((p) => (
                <CommandItem key={p.id} value={p.id}
                  onSelect={() => { onChange(p.id); setOpen(false); setQuery(""); }}
                  data-testid={`${testId}-item-${p.id}`}>
                  <Check className={`mr-2 h-4 w-4 ${value === p.id ? "opacity-100" : "opacity-0"}`} />
                  {p.name}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
